import React, {ReactNode} from 'react';

import {ReactComponent as LeftArrowIcon} from '../../../assets/svg/arrow-left.svg';

import {Icon} from '../../ui-kit/Icon';

import {Wrapper, CustomLink} from './styled';

interface Props {
    to: string;
    children: ReactNode;
    className?: string;
    isBack?: string;
}

export const BackTo = ({to, children, className, isBack = '?isBack=true'}: Props) => (
    <Wrapper className={className}>
        <CustomLink to={`${to}${isBack}`}>
            <Icon source={LeftArrowIcon} height={14} width={14} />
            {children}
        </CustomLink>
    </Wrapper>
);
